import React from 'react'
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
import './footer.css';
import { FaArrowRight, FaFacebook, FaLinkedin, FaInstagram } from 'react-icons/fa'
function Footer() {
    return (
        <section className='footerSection pt-5'>
            <Container >
                <div className='row'>
                    <div className='col-md-3 col-lg-3 col-sm-12'>
                        <ul className='footMenu list-unstyled'>
                            <li><Link to="/aboutus">About Team</Link></li>
                            <li><Link to="/life">Life at KibbCom</Link></li>
                            <li><Link to="/blog">Blogs</Link></li>
                            <li><Link to="/values">Values</Link></li>
                            <li><Link to="/careers">Careers</Link></li>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                        </ul>
                    </div>
                    <div className='col-md-5 col-lg-5 col-sm-12'>
                        <h5 className='footServiceHeading'>Services</h5>
                        <ul className='footServiceLink list-unstyled' style={{ columns: 2, columnGap: '2rem' }}>
                            <li><Link to="/services#customSoftware">Custom Software Dev</Link></li>
                            <li><Link to="/services#erpSaas">ERP & SaaS Solutions</Link></li>
                            <li><Link to="/services#mobileApp">Mobile App Dev</Link></li>
                            <li><Link to="/services#webApp">Web App Dev</Link></li>
                            <li><Link to="/services#powerBI">Power BI & Analytics</Link></li>
                            <li><Link to="/services#iotSolutions">IoT Solutions</Link></li>
                            <li><Link to="/services#cloudInfra">Cloud & On-Prem Servers</Link></li>
                            <li><Link to="/services#websiteDev">Website Development</Link></li>
                            <li><Link to="/services#embedded">Embedded Software</Link></li>
                            <li><Link to="/services#electricVehicle">eMobility</Link></li>
                            <li><Link to="/services#cloudComputing">Cloud Computing</Link></li>
                            <li><Link to="/services#industry40">Industry 4.0</Link></li>
                        </ul>
                    </div>
                    {/* <div className='col-md-4 col-lg-4 col-sm-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <p className='footBodyContent'>We’re hiring! <br /> Learn about careers at KibbCom</p>
                                <Link className='btn positionBtn' to="/careers">Explore Positions <FaArrowRight></FaArrowRight></Link>
                            </div>
                        </div>
                    </div> */}
                </div>

                <hr />

                <div className='row contactFooterReverse'>
                    <div className='col-lg-6 col-sm-12 col-xs-12'>
                        <p>© {(new Date().getFullYear())} KibbCom</p>
                    </div>
                    <div className='col-lg-6 col-sm-12 col-xs-12'>
                        <ul className='footSocialLink list-inline'>
                            <li className='list-inline-item'>
                                <a href="https://www.linkedin.com/company/kibbcom-india/" target="_blank">
                                    <FaLinkedin className='linkedin socialIcon' />
                                </a>
                            </li>
                            <li className='list-inline-item'>
                                <a href="https://www.facebook.com/kibbcom" target="_blank"><FaFacebook className='fb socialIcon' /></a>
                            </li>
                            <li className='list-inline-item'>
                                <a href="https://www.instagram.com/kibbcom/?hl=en" target="_blank"><FaInstagram className='instagram socialIcon' /></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </Container>
        </section>
    );
}

export default Footer;